import React, { Component } from 'react';
import { Value } from 'react-data-grid-addons';
import { Cell, Grid } from 'react-md';
import { SegmentedControl } from 'segmented-control';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Properties from '../component/Properties';
import SecureShow from '../component/SecureShow';
import '../css/archive.css';
import '../css/Dashboard.css';
import StudentEnrollmentList from '../pages/StudentEnrollmentList';
import QuizList from '../pages/QuizList';



export default class SubSectionTabs extends Component {
    constructor(props){
        super(props);
        this.state = {
            showStudents: false,
            course_id: this.props.location.query.course_id,
            course_name: this.props.location.query.course_name,
            section_name: this.props.location.query.section_name,
            section_id: this.props.location.query.section_id,
            subsection_name: this.props.location.query.subsection_name,
            subsection_id: this.props.location.query.subsection_id
        }
    }


    tabOnChange =(clickedValue) => {
        if(clickedValue === 'Students'){
            this.setState({showStudents: true, showQuizzes: false});
        }
        if(clickedValue === 'Quizzes'){
            this.setState({showStudents:false, showQuizzes:true});
        }
    }

    render(){
        return (
        <SecureShow targetRole={1}>
            <Grid gutter={1} >
                <Cell size={10}> 
                    <SegmentedControl 
                     name= "subsection_tabs"
                     style={{color: '#bb0000'}}
                     options ={[
                         { label: 'Assignments', value: 'Quizzes', default: true },
                         { label: 'Students', value: 'Students' }
                     ]}
                     setValue={newValue => this.tabOnChange(newValue)}
                    />
                </Cell>
                {
                    this.state.showQuizzes?
                    <Cell size={12} className="gradebook-cell">   
                    <QuizList {...this.props} subSection={true} />
                    </Cell>
                    :
                    undefined
                }
                {
                    this.state.showStudents?
                    <Cell size={12} className="gradebook-cell">   
                    <StudentEnrollmentList {...this.props}  />
                    </Cell>
                    :
                    undefined
                }
            </Grid>
        </SecureShow>)
    }
}

